import React from 'react';
import { ConfirmDialog } from 'swag-client-common/components/info/confirm-dialog';
export const EmbellishmentMethodChangeConfirmationPopup = allProps => {
  const {
    open,
    methodId,
    onConfirm,
    onCancel,
    onItemConfirm,
    isItemEdit,
    itemId,
    productionTimeId,
    storageType
  } = allProps;
  const handleConfirm = () => {
    if (isItemEdit) {
      onItemConfirm({
        itemId,
        embellishmentMethodId: methodId,
        productionTimeIdx: productionTimeId,
        storageType
      });
    } else {
      onConfirm(methodId);
    }
  };
  const handleCancel = () => {
    onCancel();
  };
  return /*#__PURE__*/React.createElement(ConfirmDialog, {
    title: "You are changing your decorating method",
    msg: "Production times vary by decorating method, so please check the updated timeline to make sure it works for you!",
    confirmText: "Confirm",
    open: open,
    onConfirm: handleConfirm,
    onCancel: handleCancel
  });
};